import { baseApi } from '@/config/axios';
import {
  AISessionResponse,
  AIChatHistoryResponse,
  AIChatSendMessageParams,
  AIChatSendMessageResponse,
  ProactiveMessageResponse,
  DeliverProactiveMessageResponse,
} from '@/types/api/aiChat';
import { getAiLoginType } from '@/utils/aiLoginType';

/**
 * AIセッション取得/作成
 * セッションキー（ログイン識別子）は認証済み顧客からサーバ側が導出するため送らない
 */
export const getAISessionApi = (): Promise<AISessionResponse> =>
  baseApi.get('/v1/customer/ai/session');

/**
 * 対話履歴取得
 * 常に最新側から limit 件返る。遡る場合は before_id に
 * 画面が持っている一番古いメッセージのIDを渡す
 */
export const getAIChatHistoryApi = (params: {
  limit?: number;
  before_id?: number;
}): Promise<AIChatHistoryResponse> =>
  baseApi.get('/v1/customer/ai/history', { params });

/**
 * メッセージ送信（HTTP fallback）
 *
 * login_type は「AIが参照する顧客レコードの範囲」を車両切替の表示範囲と
 * 揃えるためにサーバが使う。識別子の値は送らない（サーバが認証情報から引く）。
 */
export const postAIChatMessageApi = (
  params: AIChatSendMessageParams,
): Promise<AIChatSendMessageResponse> =>
  baseApi.post('/v1/customer/ai/chat', {
    ...params,
    login_type: getAiLoginType(),
  });

/**
 * プロアクティブメッセージ取得
 * ホーム画面表示時にAIからの能動的なメッセージを取得する
 */
export const getProactiveMessageApi = (): Promise<ProactiveMessageResponse> =>
  baseApi.get('/v1/customer/ai-agent/proactive-message', {
    params: { login_type: getAiLoginType() },
  });

/**
 * 声がけを対話履歴に引き渡す
 *
 * ホーム画面に出しただけでは履歴に入れない。利用者がカードをタップして
 * チャットを開いた時点で投入する（見ていない発言を文脈に入れないため）。
 * サーバ側で1回だけに制限しているので、重複タップは害にならない。
 */
export const deliverProactiveMessageApi =
  (): Promise<DeliverProactiveMessageResponse> =>
    baseApi.post('/v1/customer/ai-agent/proactive-message/deliver');
